import { useState, useEffect } from "react";
import { Input } from "./ui/input";
import { formatNumber } from "../lib/format";

export function RupiahInput({ value, onChange, className = "", ...props }) {
  const [text, setText] = useState(value ? formatNumber(value) : "");

  useEffect(() => {
    setText(value ? formatNumber(value) : "");
  }, [value]);

  const handle = (e) => {
    const digits = e.target.value.replace(/[^0-9]/g, "");
    const num = digits ? parseInt(digits, 10) : 0;
    setText(digits ? formatNumber(num) : "");
    onChange(num);
  };

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm pointer-events-none">Rp</span>
      <Input value={text} onChange={handle} inputMode="numeric"
        className={`pl-9 font-mono ${className}`} {...props} />
    </div>
  );
}
